export class StudyEventDefinition {
  constructor(params = {}) {
    this.id = params.id;
    this.displayName = params.displayName;
    this.identifier = params.identifier;
    this.position = params.position;
    this.studyArm = params.studyArm || null;
  }
}

export default StudyEventDefinition;
